import { Box, Stack, Typography } from "@mui/material";
import React from "react";

export default function BilletInfoSection({ billet }) {
    const [event , setEvent] = React.useState(null);

    return <Box sx={{display: 'flex', flexDirection: 'column', gap: 2, p: 2, borderRadius: 1}}>
        <Stack direction="row" spacing={2} alignItems="center">
            <Typography variant="body1" textTransform='capitalize'>Billet {billet.owner?.nom+' '+billet.owner?.prenom}</Typography>
            <Typography variant="body1">{billet.price?.toFixed(2)} €</Typography>
        </Stack>
    </Box>
}